/*
 * XYNE Redesign — PDP product hero logic
 * Variant option visual selection, quantity, subscription toggle, thumb gallery
 * (with src+srcset swap and fade transition), fullscreen lightbox, sticky ATC.
 */
(function () {
  'use strict';

  // ---------- Urgency countdown ----------
  // Computes time remaining until today's shipping cutoff in the merchant's
  // timezone, updates every 30s. Past cutoff shows "Ships next business day".
  // Added 2026-05-16 for conversion uplift on cold ad traffic.
  function initUrgency() {
    var urgency = document.querySelector('[data-rd-urgency]');
    if (!urgency) return;
    var countdownEl = urgency.querySelector('[data-rd-urgency-countdown]');
    if (!countdownEl) return;

    var cutoffHour = parseInt(urgency.getAttribute('data-rd-urgency-cutoff-hour'), 10);
    if (isNaN(cutoffHour) || cutoffHour < 0 || cutoffHour > 23) cutoffHour = 14;
    var tz = urgency.getAttribute('data-rd-urgency-tz') || 'America/Chicago';

    function partsInTZ(date) {
      // Returns { y, m, d, h, mi, s } in the configured timezone.
      try {
        var fmt = new Intl.DateTimeFormat('en-US', {
          timeZone: tz,
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit',
          hour12: false
        });
        var parts = fmt.formatToParts(date);
        var out = {};
        parts.forEach(function (p) { out[p.type] = p.value; });
        return {
          y: parseInt(out.year, 10),
          m: parseInt(out.month, 10),
          d: parseInt(out.day, 10),
          h: parseInt(out.hour === '24' ? '0' : out.hour, 10),
          mi: parseInt(out.minute, 10),
          s: parseInt(out.second, 10)
        };
      } catch (e) {
        // Fallback to local time
        return { y: date.getFullYear(), m: date.getMonth() + 1, d: date.getDate(),
                 h: date.getHours(), mi: date.getMinutes(), s: date.getSeconds() };
      }
    }

    function tick() {
      var now = new Date();
      var p = partsInTZ(now);
      var cutoffSecondsToday = cutoffHour * 3600;
      var nowSecondsToday = p.h * 3600 + p.mi * 60 + p.s;
      var remaining = cutoffSecondsToday - nowSecondsToday;

      if (remaining > 0) {
        urgency.classList.remove('is-past-cutoff');
        urgency.classList.add('is-active');
        var hrs = Math.floor(remaining / 3600);
        var mins = Math.floor((remaining % 3600) / 60);
        if (hrs > 0) {
          countdownEl.textContent = hrs + 'h ' + (mins < 10 ? '0' : '') + mins + 'm';
        } else {
          countdownEl.textContent = mins + 'm';
        }
      } else {
        // Past cutoff — pre-cutoff promised "ship tomorrow"; post-cutoff
        // we slip the ship date by one business day. Honest framing.
        urgency.classList.add('is-past-cutoff', 'is-active');
        var prefix = urgency.querySelector('[data-rd-urgency-text]');
        if (prefix && !prefix.dataset.swapped) {
          prefix.dataset.swapped = '1';
          prefix.innerHTML = 'Order today — <strong>ships in 2 business days</strong>';
        }
      }
    }

    tick();
    setInterval(tick, 30000);
  }

  function init() {
    initUrgency();

    var form = document.getElementById('rd-pdp-form');
    if (!form) return;

    var qtyInput = document.getElementById('rd-pdp-qty');
    var mainImg = document.getElementById('rd-pdp-main-img');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.rd-pdp__thumb'));

    // ---------- Quantity ----------
    document.querySelectorAll('.rd-pdp__qty button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var change = parseInt(btn.dataset.qty, 10);
        var current = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, Math.min(99, current + change));
      });
    });

    // ---------- Volume packs (buy more, save more) ----------
    var packsRoot = document.querySelector('[data-rd-packs]');
    var pillsRoot = document.querySelector('[data-rd-purchase-pills]');
    var sellingPlanInput = document.querySelector('[data-rd-selling-plan-input]');
    var pdpPriceEl = document.getElementById('rd-pdp-price');
    var stickyPriceEl = document.querySelector('.rd-pdp__sticky-price');

    // Purchase mode state — flips between 'onetime' and 'subscription'.
    // Default: 'onetime' (Brandon 2026-06-30 — flipped back from the
    // 2026-06-27 override that had defaulted to Subscribe. Headline price,
    // pack tile prices, and the hidden selling_plan input all default to
    // one-time on first paint. JS swaps every downstream value when the
    // shopper picks Subscribe & save.)
    var purchaseMode = 'onetime';
    var subDiscountPct = pillsRoot
      ? (parseInt(pillsRoot.getAttribute('data-sub-discount-pct'), 10) || 0)
      : 0;
    var subPlanId = pillsRoot ? pillsRoot.getAttribute('data-sub-plan-id') : '';

    if (packsRoot) {
      var variantPriceCents = parseInt(packsRoot.getAttribute('data-variant-price'), 10) || 0;
      var packTiles = Array.prototype.slice.call(packsRoot.querySelectorAll('.rd-pdp__pack'));

      // Apply current purchase mode to a per-tile total. Sub mode reduces
      // the price by subDiscountPct.
      function tilePriceCents(tile) {
        var base = parseInt(tile.getAttribute('data-tier-total'), 10) || 0;
        if (purchaseMode === 'subscription' && subDiscountPct > 0) {
          base = Math.round(base * (100 - subDiscountPct) / 100);
        }
        return base;
      }

      // Update visible price/compare/per-pack on each tile to match the
      // current purchase mode (called on init and whenever purchase mode
      // toggles).
      function repriceAllTiles() {
        packTiles.forEach(function (tile) {
          var packCount   = parseInt(tile.getAttribute('data-pack-count'), 10) || 1;
          var tierSavingsPct = parseInt(tile.getAttribute('data-savings-pct'), 10) || 0;
          var subtotal   = variantPriceCents * packCount;
          var tierTotal  = parseInt(tile.getAttribute('data-tier-total'), 10) || subtotal;
          if (purchaseMode === 'subscription' && subDiscountPct > 0) {
            tierTotal = Math.round(tierTotal * (100 - subDiscountPct) / 100);
          }
          var priceEl   = tile.querySelector('[data-pack-total]');
          var compareEl = tile.querySelector('[data-pack-compare]');
          var perEl     = tile.querySelector('[data-pack-per]');
          if (priceEl)   priceEl.textContent   = formatMoney(tierTotal);
          if (compareEl && purchaseMode === 'subscription') compareEl.textContent = formatMoney(subtotal);
          if (perEl && packCount > 1) perEl.textContent = formatMoney(Math.round(tierTotal / packCount));
        });
      }

      function selectPack(tile) {
        if (!tile) return;
        var packCount = parseInt(tile.getAttribute('data-pack-count'), 10) || 1;
        var totalCents = tilePriceCents(tile);

        // Visual selection
        packTiles.forEach(function (t) {
          t.classList.remove('rd-pdp__pack--selected');
          t.setAttribute('aria-checked', 'false');
        });
        tile.classList.add('rd-pdp__pack--selected');
        tile.setAttribute('aria-checked', 'true');

        // Sync the form quantity input
        if (qtyInput) qtyInput.value = packCount;

        // Update the headline PDP price + sticky price
        if (pdpPriceEl)   pdpPriceEl.textContent   = formatMoney(totalCents);
        if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(totalCents);
      }

      packTiles.forEach(function (tile) {
        tile.addEventListener('click', function () { selectPack(tile); });
        tile.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
            e.preventDefault();
            var next = packTiles[(packTiles.indexOf(tile) + 1) % packTiles.length];
            next.focus(); selectPack(next);
          } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var prev = packTiles[(packTiles.indexOf(tile) - 1 + packTiles.length) % packTiles.length];
            prev.focus(); selectPack(prev);
          } else if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            selectPack(tile);
          }
        });
      });

      // Expose repriceAllTiles + selectedTile lookup so the pill handler
      // below can refresh prices when mode toggles.
      packsRoot.__rdPdpRepriceTiles = repriceAllTiles;
      packsRoot.__rdPdpReselectActive = function () {
        var active = packsRoot.querySelector('.rd-pdp__pack--selected') || packTiles[0];
        if (active) selectPack(active);
      };

      // Apply the server-rendered default on init
      var initialTile = packsRoot.querySelector('.rd-pdp__pack--selected') || packTiles[0];
      if (initialTile) selectPack(initialTile);
    }

    // ---------- Purchase pills (one-time vs subscription) ----------
    if (pillsRoot) {
      var pills = Array.prototype.slice.call(pillsRoot.querySelectorAll('[data-rd-purchase]'));

      // 2026-06-27: Read base + subscribed prices from the pills root so
      // we can drive the headline .rd-pdp__price element when the user
      // toggles modes. Stored in cents (Shopify's native price unit).
      var basePriceCents = parseInt(pillsRoot.getAttribute('data-variant-price'), 10) || 0;
      var subPriceCents  = parseInt(pillsRoot.getAttribute('data-sub-price'), 10) ||
                           Math.round(basePriceCents * (100 - subDiscountPct) / 100);
      var headlinePriceEl = document.querySelector('[data-rd-headline-price]') ||
                            document.getElementById('rd-pdp-price');
      var onetimePillMetaEl = document.querySelector('[data-rd-pill-onetime-meta]');

      function setPurchaseMode(mode) {
        if (mode !== 'onetime' && mode !== 'subscription') return;
        purchaseMode = mode;

        pills.forEach(function (p) {
          var isActive = p.getAttribute('data-rd-purchase') === mode;
          p.classList.toggle('rd-pdp__purchase-pill--active', isActive);
          p.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        // Toggle the form's selling_plan value so the cart picks up the
        // right purchase mode.
        if (sellingPlanInput) {
          sellingPlanInput.value = (mode === 'subscription' && subPlanId) ? subPlanId : '';
        }

        // 2026-06-27: Headline .rd-pdp__price element updates as the user
        // toggles modes. Subscribe = discounted price; One-time = base
        // variant price. Both displays use Shopify's money formatter via
        // formatMoney() so currency + locale stay consistent.
        if (headlinePriceEl) {
          var displayCents = (mode === 'subscription') ? subPriceCents : basePriceCents;
          headlinePriceEl.textContent = formatMoney(displayCents);
        }

        // One-time pill meta — show the base price + "ships once" so the
        // user can see what they'd be paying without the discount.
        if (onetimePillMetaEl) {
          onetimePillMetaEl.textContent = formatMoney(basePriceCents) + ' · ships once';
        }

        // Pack tile prices need to refresh for the new mode (no-op when
        // the volume_pack picker is hidden via section setting).
        if (packsRoot && packsRoot.__rdPdpRepriceTiles) {
          packsRoot.__rdPdpRepriceTiles();
        }
        if (packsRoot && packsRoot.__rdPdpReselectActive) {
          packsRoot.__rdPdpReselectActive();
        }
      }

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          setPurchaseMode(pill.getAttribute('data-rd-purchase'));
        });
      });

      // INIT: run setPurchaseMode once on load so the displayed price + the
      // hidden selling_plan input + the pack tile prices all match the
      // SSR-default 'onetime' pill before the user clicks anything.
      // Without this, the first paint can show the wrong price because the
      // pack tiles re-render on their own initial pass.
      setPurchaseMode(purchaseMode);
    }

    // Tiny money formatter — falls back to USD if Shopify currency unknown.
    function formatMoney(cents) {
      try {
        var shop = (window.Shopify && window.Shopify.currency) || {};
        var formatter = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: shop.active || 'USD',
          minimumFractionDigits: 2
        });
        return formatter.format((cents || 0) / 100);
      } catch (e) {
        return '$' + ((cents || 0) / 100).toFixed(2);
      }
    }

    // ---------- Variant option visuals ----------
    document.querySelectorAll('.rd-pdp__variant-options').forEach(function (group) {
      var idx = group.dataset.optionIndex;
      group.querySelectorAll('.rd-pdp__variant-option').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('.rd-pdp__variant-option').forEach(function (b) {
            b.classList.remove('rd-pdp__variant-option--selected');
          });
          btn.classList.add('rd-pdp__variant-option--selected');
          var label = document.getElementById('rd-pdp-option-' + idx);
          if (label) label.textContent = btn.dataset.value;
        });
      });
    });

    // (The old `.rd-pdp__purchase-option` radio handler was replaced by
    // the purchase-pills handler above — pills now drive purchase mode
    // and recalculate pack pricing per mode.)

    // ---------- Thumbnail gallery ----------
    // Swap BOTH src and srcset on the main image so the browser actually paints
    // the selected image (just changing src is ignored when srcset is present).
    function swapMainImage(thumb) {
      if (!mainImg || !thumb) return;
      var src = thumb.dataset.imgSrc;
      var srcset = thumb.dataset.imgSrcset;
      var alt = thumb.dataset.imgAlt;
      if (!src) return;

      // Highlight the active thumb
      thumbs.forEach(function (t) { t.classList.remove('rd-pdp__thumb--active'); });
      thumb.classList.add('rd-pdp__thumb--active');

      // Fade out, swap, fade back in
      mainImg.classList.add('rd-pdp__main-img-img--swap');

      // Pre-load the new image so the swap doesn't show a blank frame
      var preload = new Image();
      preload.onload = function () {
        // Clear srcset BEFORE setting src so the browser doesn't honor the old srcset
        if (srcset) {
          mainImg.setAttribute('srcset', srcset);
        } else {
          mainImg.removeAttribute('srcset');
        }
        mainImg.src = src;
        if (alt) mainImg.alt = alt;
        // Wait one frame for paint, then fade back in
        requestAnimationFrame(function () {
          mainImg.classList.remove('rd-pdp__main-img-img--swap');
        });
      };
      preload.onerror = function () {
        // If preload fails, just swap directly
        if (srcset) mainImg.setAttribute('srcset', srcset); else mainImg.removeAttribute('srcset');
        mainImg.src = src;
        if (alt) mainImg.alt = alt;
        mainImg.classList.remove('rd-pdp__main-img-img--swap');
      };
      preload.src = src;
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        // Don't bubble into the main-img zoom trigger
        e.stopPropagation();
        swapMainImage(thumb);
      });
    });

    // Keyboard nav on the thumbs row (left/right arrows)
    var thumbsContainer = document.querySelector('.rd-pdp__thumbs');
    if (thumbsContainer) {
      thumbsContainer.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        var idx = thumbs.indexOf(document.activeElement);
        if (idx < 0) return;
        var next = e.key === 'ArrowRight' ? idx + 1 : idx - 1;
        if (next < 0) next = thumbs.length - 1;
        if (next >= thumbs.length) next = 0;
        thumbs[next].focus();
        thumbs[next].click();
        e.preventDefault();
      });
    }

    // ---------- Lightbox (tap-to-zoom, photo-mode only) ----------
    // Only wires up when the main product image button exists (photo-mode).
    // In tin-mode the photos render as an inline horizontal scroll
    // carousel below the 3D tin — no lightbox needed because the photos
    // are already at viewable size right on the page.
    var lightbox = document.getElementById('rd-pdp-lightbox');
    var trigger = document.querySelector('[data-rd-zoom-trigger]');
    if (lightbox && trigger) {
      var lbImg = lightbox.querySelector('.rd-pdp__lightbox-img');
      var lbClose = lightbox.querySelector('.rd-pdp__lightbox-close');
      var lbPrev = lightbox.querySelector('.rd-pdp__lightbox-nav--prev');
      var lbNext = lightbox.querySelector('.rd-pdp__lightbox-nav--next');
      var lbCounter = lightbox.querySelector('.rd-pdp__lightbox-counter');
      var activeIndex = 0;

      function openLightbox(idx) {
        if (typeof idx !== 'number') idx = 0;
        activeIndex = idx;
        renderLightbox();
        lightbox.hidden = false;
        document.body.classList.add('rd-pdp--lightbox-open');
        // Focus close button for keyboard users
        setTimeout(function () { if (lbClose) lbClose.focus(); }, 50);
      }
      function closeLightbox() {
        lightbox.hidden = true;
        document.body.classList.remove('rd-pdp--lightbox-open');
        if (trigger) trigger.focus();
      }
      function renderLightbox() {
        if (!lbImg) return;
        var thumb = thumbs[activeIndex] || thumbs[0];
        // No thumbs? Use main image as the only image
        var src, alt;
        if (thumb) {
          src = thumb.dataset.imgZoom || thumb.dataset.imgSrc;
          alt = thumb.dataset.imgAlt;
        } else if (mainImg) {
          src = mainImg.src;
          alt = mainImg.alt;
        }
        if (src) lbImg.src = src;
        if (alt) lbImg.alt = alt;
        if (lbCounter) {
          if (thumbs.length > 1) {
            lbCounter.textContent = (activeIndex + 1) + ' / ' + thumbs.length;
            lbCounter.hidden = false;
          } else {
            lbCounter.hidden = true;
          }
        }
        // Show prev/next only when there are multiple
        if (lbPrev) lbPrev.hidden = thumbs.length <= 1;
        if (lbNext) lbNext.hidden = thumbs.length <= 1;
      }
      function navigate(delta) {
        if (thumbs.length <= 1) return;
        activeIndex = (activeIndex + delta + thumbs.length) % thumbs.length;
        // Sync the underlying gallery's main image too
        swapMainImage(thumbs[activeIndex]);
        renderLightbox();
      }

      trigger.addEventListener('click', function () {
        // Find which thumb matches the currently displayed main image
        var matchedIdx = thumbs.findIndex(function (t) { return t.classList.contains('rd-pdp__thumb--active'); });
        openLightbox(matchedIdx >= 0 ? matchedIdx : 0);
      });

      if (lbClose) lbClose.addEventListener('click', closeLightbox);
      if (lbPrev) lbPrev.addEventListener('click', function () { navigate(-1); });
      if (lbNext) lbNext.addEventListener('click', function () { navigate(1); });

      // Close on backdrop click (but not when clicking the image or controls)
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });

      // Keyboard: Esc closes, arrows navigate
      document.addEventListener('keydown', function (e) {
        if (lightbox.hidden) return;
        if (e.key === 'Escape') closeLightbox();
        else if (e.key === 'ArrowLeft') navigate(-1);
        else if (e.key === 'ArrowRight') navigate(1);
      });

      // Touch swipe inside the lightbox
      var touchStartX = null;
      lightbox.addEventListener('touchstart', function (e) {
        if (e.touches.length === 1) touchStartX = e.touches[0].clientX;
      }, { passive: true });
      lightbox.addEventListener('touchend', function (e) {
        if (touchStartX === null) return;
        var endX = (e.changedTouches[0] || {}).clientX || touchStartX;
        var delta = endX - touchStartX;
        if (Math.abs(delta) > 50) navigate(delta < 0 ? 1 : -1);
        touchStartX = null;
      });
    }

    // ---------- Sticky ATC teleport + mirror ----------
    // The sticky bar lives inside <section class="rd-pdp"> which is inside a
    // <shopify-section> with position:relative + z-index:1 — that creates a
    // stacking context that TRAPS the sticky. Even at z-index 900, it stays
    // below other sections stacking-wise. Fix: reparent the sticky element to
    // <body> so it escapes the section's stacking context entirely and its
    // fixed positioning + z-index actually put it on top of the page.
    var stickyBar = document.querySelector('.rd-pdp__sticky');
    if (stickyBar && stickyBar.parentElement !== document.body) {
      document.body.appendChild(stickyBar);
    }

    // Bulletproof click handler: find the visible (not disabled/hidden) real ATC
    // button and submit its <product-form> parent directly. This dispatches the
    // proper 'submit' event that Atlas Bolt's <product-form> custom element
    // intercepts for AJAX add-to-cart.
    // ---------- Sticky ATC visibility ----------
    // Show the bar only once the real Add-to-Bag button has left the viewport.
    // Runs at every width: on desktop the buy box sits ~1,480px down (approved
    // 2026-08-03), so without this there is no persistent buy action at all.
    // Falls back to always-visible if IntersectionObserver is unavailable.
    (function () {
      if (!stickyBar) return;
      var realAtcForObs = document.querySelector('.rd-pdp__atc');
      if (!realAtcForObs || typeof IntersectionObserver !== 'function') {
        stickyBar.classList.add('is-visible');
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Visible when the real button is NOT on screen.
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { rootMargin: '0px 0px -80px 0px', threshold: 0 });
      io.observe(realAtcForObs);
    })();

    var stickyBtn = document.querySelector('.rd-pdp__sticky-cta');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();

        // Prefer the visible ATC button — filter out any hidden/disabled duplicates.
        var candidates = document.querySelectorAll('.rd-pdp__atc');
        var realAtc = null;
        for (var i = 0; i < candidates.length; i++) {
          var b = candidates[i];
          var visible = b.offsetParent !== null && !b.disabled && !b.hasAttribute('hidden');
          if (visible) { realAtc = b; break; }
        }
        // Fallback: any .rd-pdp__atc that lives inside a <product-form>
        if (!realAtc) {
          for (var j = 0; j < candidates.length; j++) {
            if (candidates[j].closest('product-form')) { realAtc = candidates[j]; break; }
          }
        }
        if (!realAtc) return;

        // Preferred path: submit the parent <product-form> directly. This is
        // what Atlas Bolt's custom-element listens for.
        var form = realAtc.closest('form') || realAtc.closest('product-form') && realAtc.closest('product-form').querySelector('form');
        if (form && typeof form.requestSubmit === 'function') {
          form.requestSubmit(realAtc);
          return;
        }
        if (form) {
          // Older browsers without requestSubmit — fall back to dispatching submit
          form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
          return;
        }
        // Final fallback: synthetic click.
        realAtc.click();
      });
    }

    // ---------- Live photos rail (tin-mode inline carousel) ----------
    // Photos render as a horizontal scroll-snap carousel below the 3D
    // tin. Dot indicators reflect the active slide and click-jump-scroll
    // to it. Scroll position updates the active dot.
    var livePhotos = document.querySelector('[data-rd-live-photos]');
    if (livePhotos) {
      var rail  = livePhotos.querySelector('.rd-pdp__live-rail');
      var slides = Array.prototype.slice.call(livePhotos.querySelectorAll('[data-rd-live-slide]'));
      var dots  = Array.prototype.slice.call(livePhotos.querySelectorAll('[data-rd-live-dot]'));

      function setActive(idx) {
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
      }

      // Click a dot → smooth-scroll the rail to that slide
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          var slide = slides[i];
          if (!slide || !rail) return;
          var offset = slide.offsetLeft
            - (rail.clientWidth / 2)
            + (slide.clientWidth / 2);
          rail.scrollTo({ left: offset, behavior: 'smooth' });
        });
      });

      // Watch which slide is centered and update the active dot
      if (rail && 'IntersectionObserver' in window) {
        var railObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              var idx = parseInt(entry.target.getAttribute('data-rd-live-slide'), 10);
              if (!isNaN(idx)) setActive(idx);
            }
          });
        }, { root: rail, threshold: [0.6, 0.75, 0.9] });
        slides.forEach(function (s) { railObserver.observe(s); });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
